import validator from "validator";

export const regex = {
  email:
    /[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g,
  identityNumber: /^[A-Z0-9a-z]{3,17}$/g, // same for NRIC and passport number
  nonAlphanumeric: /[^a-zA-Z0-9]/g,
  legalName: /^([a-zA-Z \\,'/-]*)$/,
  alphanumeric: /^([a-zA-Z0-9\/]+)$/,
  alphanumericWithHypen: /^([a-zA-Z0-9\-]+)$/,
  alphanumericWithUnderscoreAndHypen: /^([a-zA-Z0-9-_]+)$/,
  onlyDigit: /^([0-9]+)$/,
  alphanumericWithSpecialCharacter: /^([a-zA-Z0-9 \\,'`"/_-]+)$/,
  gender: /(MALE|FEMALE|UNKNOWN)/g,
  passType: /(S Pass)/g,
  sgCitizenship: /(FOREIGNER|SINGAPORE CITIZEN|SINGAPORE PR)/g,
  password:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\ !\"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]).{8,}$/,
};

export const isValidEmail = (email: string) => {
  const isValid = validator.isEmail(email);
  if (email !== "" && !isValid) return "Invalid email address";
};
